import { addPxSuffix } from '@/src/helpers';
import { FieldError } from 'react-hook-form';
import styled, { css } from 'styled-components';

type StyleProps = {
  $error?: FieldError | undefined;
  $width?: string | number;
  open?: boolean;
};

const inputCss = css`
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.colors.lineGrey};
  border-radius: 5px;
  width: 100%;
  margin-top: 5px;
  font-family: Gotham;
  font-size: 16px;
  font-style: normal;
  font-weight: 325;
  line-height: 156%;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.orangePeel};
  }

  &:-webkit-autofill {
    animation-name: autofillStart;
    animation-duration: 0.01s;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.m}) {
    margin-top: 10px;
  }
`;

const Input = styled.input<{ $error?: boolean; $width: string | number }>`
  ${inputCss}

  ${({ $error, theme }) =>
    $error &&
    css`
      border-color: ${theme.colors.orangePeel};
    `}

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.m}) {
    width: ${({ $width }) => addPxSuffix($width)};
  }
`;

const TextArea = styled.textarea<{ $error?: boolean }>`
  ${inputCss}
  resize: none;
  min-height: 120px;

  ${({ $error, theme }) =>
    $error &&
    css`
      border-color: ${theme.colors.orangePeel};
    `}
`;

const DropdownWrapper = styled.div<StyleProps>`
  position: relative;
  display: inline-block;

  font-family: Gotham;
  font-size: 16px;
  font-style: normal;
  font-weight: 325;
  line-height: 156%;
  width: 100%;

  &::after {
    content: '';
    position: absolute;
    top: 55%;
    right: 10px;
    border-left: 1.5px solid black;
    border-bottom: 1.5px solid black;
    height: 7px;
    width: 7px;
    transform: translateY(-50%) rotate(-45deg);
  }
`;

const Search = styled.input<StyleProps>`
  ${inputCss}
  background-color: #fff;
  cursor: pointer;
  user-select: none;
  width: 100%;
  min-height: 46.95px;

  ${({ $error, theme }) =>
    $error &&
    css`
      border-color: ${theme.colors.orangePeel};
    `}
`;

const SelectedItem = styled.div<StyleProps>`
  ${inputCss}
  background-color: #fff;
  cursor: pointer;
  user-select: none;
  width: 100%;
  min-height: 46.95px;

  ${({ $error, theme }) =>
    $error &&
    css`
      border-color: ${theme.colors.orangePeel};
    `}
`;

const DropdownList = styled.div<StyleProps>`
  position: absolute;
  top: 98%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid ${({ $error }) => ($error ? 'red' : '#ccc')};
  border-top: none;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  display: ${(props) => (props.open ? 'block' : 'none')};
`;

const DropdownItem = styled.div`
  padding: 10px;
  cursor: pointer;

  &:hover {
    background-color: #f0f0f0;
  }
`;

const DropdownContent = styled.div``;

const SearchInput = styled.input`
  width: 100%;
  padding: 8px;
  margin-bottom: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

const NoResults = styled.div`
  padding: 8px;
  color: #666;
  text-align: center;
`;

const S = {
  Input,
  TextArea,
  DropdownWrapper,
  Search,
  DropdownList,
  DropdownItem,
  DropdownContent,
  SearchInput,
  SelectedItem,
  NoResults,
};

export default S;
